module.exports = __webpack_public_path__ + "img/arrow-up-from-bracket.7980de04.svg";